var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-img',{attrs:{"height":"400","contain":"","src":require("../../assets/chatwelcome.png")}}),_c('div')],1)}
var staticRenderFns = []

export { render, staticRenderFns }